import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { STATUS_API, PAGE_SIZE_LIST } from 'src/app/constant/config';
import { useQuery } from 'src/app/hooks/useQuery.js';
import { _convertObjectToQuery } from 'src/app/utils/apiService.js';
import { makeStyles } from '@material-ui/core';
import Toolbar from './ToolBar';
import Result from './Result';
import { getListSafeZones } from 'src/features/safeZoneSlice';

const SafeZonesTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const query = useQuery();

  const listSafeZones = useSelector(state => state.safeZoneSlice.listSafeZones);
  const totalSafeZones = useSelector(state => state.safeZoneSlice.totalSafeZones);
  const statusCreate = useSelector(state => state.safeZoneSlice.statusCreate);
  const statusDelete = useSelector(state => state.safeZoneSlice.statusDelete);
  const statusUpdate = useSelector(state => state.safeZoneSlice.statusUpdate);

  const userId = useSelector(state => state.authSlice.userId);

  const params = useMemo(() => {
    return {
      page: query.get('page') || 1,
      page_size: PAGE_SIZE_LIST,
      keywords: query.get('keywords') || undefined
    }
  },[query]);

  useEffect(() => {
    if (userId) {
      dispatch(getListSafeZones(params));
    } 
  }, [userId, params]);

  const getListSafeZonesWithParams = query => {
    navigate('/app/manage/safe-zone?' + _convertObjectToQuery(query));
  };

  useEffect(() => {
    if (statusCreate === STATUS_API.SUCCESS || statusDelete === STATUS_API.SUCCESS || statusUpdate === STATUS_API.SUCCESS) {
      dispatch(getListSafeZones(params));
    }
  }, [statusCreate, statusDelete, statusUpdate]);

  return (
    <>
      <div className={classes.root}>
        <div style={{ width: '98%', margin: '0 auto' }}>
          <Toolbar 
            searchRef={getListSafeZonesWithParams} 
          />

          <Result
            className="mt-3"
            listSafeZones={listSafeZones}
            totalSafeZones={totalSafeZones}
            getListCustomerRef={getListSafeZonesWithParams}
            currentParams={params}
          />
        </div>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    marginTop: '17px'
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 auto',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

export default SafeZonesTable;
